import { render, staticRenderFns } from "./ChemUTS47E2Datasheet.vue?vue&type=template&id=cb2ec4de&"
import script from "./ChemUTS47E2Datasheet.vue?vue&type=script&lang=js&"
export * from "./ChemUTS47E2Datasheet.vue?vue&type=script&lang=js&"
import style0 from "./ChemUTS47E2Datasheet.vue?vue&type=style&index=0&id=cb2ec4de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VRow,VSimpleTable,VTextField})
